<template>

  <el-header>法宝大数据分析平台
    <div class="rop" v-if="ishow">
      <div style="text-align: center">
        <span>{{useName}}，你好</span>
        <div class="hov">
          <a @click="toPage('/#/own')">个人中心</a>
          <span @click="logout">退出登录</span>
        </div>
      </div>
    </div>
  </el-header>
</template>
<script>
    export default {
        name: 'verification',
        components: {},
        data() {
            return {
              useName:'酒神月',
              ishow:true
            }
        },
        methods: {
          toPage(url){
            window.location = url;
            window.location.reload()
          },
          logout(){
            this.$http.get(this.$store.state.url+'/user/logout').then(function(res){
              this.$message('成功退出');
              var _this = this;
              setTimeout(function () {

                _this.toPage('/#/login')
              })
            }).catch(function (error) {

            })
          }
        },
      mounted(){
          if(window.location.href.indexOf('reg')>-1){
            this.ishow = false
          }
        this.$http.get(this.$store.state.url+'/user/getUserStatus').then(function(res){
          if(res.body.status=='success'){
            console.log( res.body.data)
            this.$store.state.user = res.body.data;
            this.useName = res.body.data.name==null?res.body.data.tel:res.body.data.name;

          }else{

            if(window.location.href.indexOf('reg')>-1){

              return
            }else if(window.location.href.indexOf('login')>-1){

              return
            }
            this.toPage("/#/login")

          }
        }).catch(function (error) {

          if(window.location.href.indexOf('reg')>-1){

            return
          }else if(window.location.href.indexOf('login')>-1){

            return
          }
          this.toPage("/#/login")

        })

      }
    }
</script>
<style scoped>
.rop{
  float: right;
  font-size: 16px;
}
.rop a{
  color: #fff;
  text-decoration: none;
}
.rop span{
  padding: 0 20px;
  cursor: pointer;
}
.rop>div:hover .hov{
  display: block;
}
  .hov{
    display: none;
    background: #1c3664;
    line-height: 36px;
    z-index: 99;
    position: relative;
  }
.hov a,.hov span{
  padding: 0 20px;
  display: block;
  border-bottom: 1px solid #f4f4f4;

}
</style>



// WEBPACK FOOTER //
// src/components/header.vue